import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TDocumentsDefinition = {
  noDocumentsLabel: string;
  title: string;
  sections: {
    name: string;
    documents: {
      name: string;
      url: string;
      docId?: string;
    }[];
  }[];
};

const documentsSlice = createSlice({
  name: 'documentsSlice',
  initialState: { documents: null } as {
    documents: TDocumentsDefinition | null;
  },
  reducers: {
    setDocuments(
      state,
      { payload }: PayloadAction<TDocumentsDefinition | null>,
    ) {
      state.documents = payload;
    },
  },
});

export const documentsActions = documentsSlice.actions;

export default documentsSlice.reducer;
